export const formatCurrency = (value, currency = 'USD') => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
};

export const formatNumber = (value, decimals = 2) => {
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(value);
};

export const formatPercentage = (value) => {
  return `${value >= 0 ? '+' : ''}${value.toFixed(2)}%`;
};

export const formatDate = (date) => {
  return new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(new Date(date));
};

export const getPercentageColor = (percentage) => {
  if (percentage >= 2) return 'text-green-500';
  if (percentage >= 1) return 'text-yellow-500';
  return 'text-gray-400';
};

export const getPercentageBg = (percentage) => {
  if (percentage >= 2) return 'bg-green-500/10 border-green-500/20';
  if (percentage >= 1) return 'bg-yellow-500/10 border-yellow-500/20';
  return 'bg-gray-500/10 border-gray-500/20';
};

// USD to IDR exchange rate
export const USD_TO_IDR = 16385;

// Format IDR currency
export const formatIDR = (value) => {
  return new Intl.NumberFormat('id-ID', {
    style: 'currency',
    currency: 'IDR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value);
};

// Format crypto price in IDR (with more decimal places for smaller values)
export const formatCryptoIDR = (value, decimals = 2) => {
  const idrValue = value * USD_TO_IDR;
  if (idrValue < 1000) {
    decimals = Math.max(decimals, 2);
  }
  return new Intl.NumberFormat('id-ID', {
    style: 'currency',
    currency: 'IDR',
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(idrValue);
};